import { normalizeRequirementType } from './requirementType';
import { toDateInputValue } from './dateFormat';
import { padAssessments } from './requirementAssessments';
import { REQUIREMENT_EXTRA_DEFAULTS } from '../Components/ui/RequirementExtraFields';

/**
 * Maps an existing requirement to Add Requirement form state.
 * Excludes regId, client, typeOfContract, assignments, and runtime/history fields.
 */
export function buildDuplicatePrefillFromRequirement(requirement = {}) {
  const paddedAssessments = padAssessments(requirement.assessments || []);
  const assessmentsForm = paddedAssessments.map((row) => ({
    Assessment: row.assessment || '',
    Yoe: row.yoe || '',
  }));

  return {
    selectedClient: { ClientId: '', ClientName: '' },
    typeOfContract: '',
    startDate: toDateInputValue(requirement.startDate) || '',
    duration: requirement.duration || '',
    location: requirement.location || '',
    sourceCtc: requirement.sourceCtc || '',
    ectc: requirement.ectc || '',
    qualification: requirement.qualification || '',
    yearsExperience: requirement.yearsExperience || '',
    relevantExperience: requirement.relevantExperience || '',
    skill: requirement.skill || '',
    role: requirement.role || '',
    requirmentType: normalizeRequirementType(requirement.requirementtype || requirement.RequirmentType) || '',
    val: assessmentsForm,
    extraFields: {
      numberOfPositions: String(requirement.numberOfPositions ?? REQUIREMENT_EXTRA_DEFAULTS.numberOfPositions),
      workMode: requirement.workMode || '',
      hiringManager: requirement.hiringManager || '',
      noticePeriodDays: requirement.noticePeriodDays || '',
      expectedOnboardDate: toDateInputValue(requirement.expectedOnboardDate) || '',
      interviewProcess: requirement.interviewProcess || '',
      remarks: requirement.remarks || '',
    },
    selectedMemberIds: [],
    jdFile: null,
  };
}
